import { render } from "./VersionDisplay.vue?vue&type=template&id=4e4b1e3f&scoped=true"
import script from "./VersionDisplay.vue?vue&type=script&lang=js"
export * from "./VersionDisplay.vue?vue&type=script&lang=js"

import "./VersionDisplay.vue?vue&type=style&index=0&id=4e4b1e3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4b1e3f"]])

export default __exports__